import React from 'react';
import { Render, Section } from '../platformui/';
import BlockTypeRenderer from '../framework/base/blocktype-renderer';

export default (props) => {
  return (
    <Section>
      <div className="row">
        <div className="columns">
          <div className="row">
            <div className="medium-8 large-5 large-push-7 u-center-medium columns">
              <Render.Block
                blocks={props.ContentRight}
                propertyName="ContentRight"
                currentPageProps={props}
              >
                <BlockTypeRenderer
                  Modifiers={{ 'c-imageblock--medium-margin': true }}
                />
              </Render.Block>
            </div>

            <div className="medium-8 large-6 large-pull-6 u-center-medium columns">
              <Render.Block
                blocks={props.ContentLeft}
                propertyName="ContentLeft"
                currentPageProps={props}
              >
                <BlockTypeRenderer />
              </Render.Block>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};
